// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Lz0L","filesListContainer":"PosDisputesFiles_filesListContainer__2WrPV","filesButton":"PosDisputesFiles_filesButton__E18Wa"};